import { SET_COUPON_VERIFY_ITEM } from '../../constants';

export const coupon = {
    setVerifyItem: (item) => {
        return { type: SET_COUPON_VERIFY_ITEM, data: item };
    },
};
